import { useEffect, useRef, useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { useAuth } from "../../AuthContext";
import { storefrontUrl } from "../constant/BaseUrl";

export default function Header({ onMenu }) {
  const { me, logout } = useAuth();
  const [open, setOpen] = useState(false);
  const ref = useRef(null);
  const navigate = useNavigate();
  useEffect(() => {
    const close = (e) => ref.current && !ref.current.contains(e.target) && setOpen(false);
    document.addEventListener("mousedown", close);
    return () => document.removeEventListener("mousedown", close);
  }, []);
  const name = me?.user_name || me?.email || "";
  return (
    <header className="topbar">
      <button className="icon-btn menu-btn" onClick={onMenu} aria-label="Open navigation">
        <i className="bi bi-list" style={{ fontSize: 20 }} />
      </button>
      <a href={storefrontUrl} target="_blank" rel="noopener noreferrer" className="btn btn-ghost btn-sm">
        <i className="bi bi-box-arrow-up-right" /> View store
      </a>
      <div className="user-chip" ref={ref}>
        <button className="row" style={{ border: 0, background: "none" }} onClick={() => setOpen((o) => !o)} aria-expanded={open} aria-haspopup="menu">
          <span className="avatar">{name.slice(0, 1).toUpperCase()}</span>
          <span style={{ textAlign: "left", lineHeight: 1.2 }}>
            <span style={{ display: "block", fontWeight: 500 }}>{name}</span>
            <span className="muted small">{me?.is_owner ? "Owner" : "Staff"}</span>
          </span>
          <i className="bi bi-chevron-down small muted" />
        </button>
        {open ? (
          <div className="menu" role="menu">
            <Link to="/profile" role="menuitem" onClick={() => setOpen(false)}>
              <i className="bi bi-person" /> My profile
            </Link>
            <button
              role="menuitem"
              onClick={() => {
                logout();
                navigate("/");
              }}
            >
              <i className="bi bi-box-arrow-right" /> Sign out
            </button>
          </div>
        ) : null}
      </div>
    </header>
  );
}
